export default "__VITE_ASSET__d6a2166b__"